import { BsArrowLeft } from "react-icons/bs";

export default function InvestorPortalDetailHeader({ title, highlight, onBack }) {
  return (
    <div className="investor-portal-detail-header d-flex align-items-center gap-3 mb-3">
      <button
        type="button"
        className="investor-portal-back-btn"
        onClick={onBack}
        aria-label="Go back"
      >
        <BsArrowLeft size={22} />
      </button>
      <h4 className="fw-bold mb-0" style={{ color: "#45464E", fontSize: "1.25rem" }}>
        {title}{" "}
        {highlight ? (
          <span style={{ color: "var(--color-primary)" }}>{highlight}</span>
        ) : null}
      </h4>
    </div>
  );
}
